module.exports = __webpack_public_path__ + "img/card_img_5.78599049.png";